export function wait(ms: number) {
  return new Promise((resolve) => {
    setTimeout(() => {
      // @ts-ignore
      resolve();
    }, ms);
  })
}

export function checkPhoneNumber(phoneNumber: string) {
  const rule = /^1[3-9]\d{9}$/;
  return rule.test(phoneNumber);
}